//  Package Imports

import { Button } from 'antd';

export default function getFooterButton(
  isInactive,
  saveButtonProps,
  form,
  onFinishHandler,
  t
) {
  // const t = useTranslate();
  return isInactive
    ? [
        <Button key="ok" type="primary" {...saveButtonProps}>
          {t('common.ok')}
        </Button>,
      ]
    : [
        <Button
          key="no"
          onClick={() => {
            const values = {
              ...form.getFieldsValue(),
              all_child_active: false,
            };
            onFinishHandler(values);
          }}
        >
          {t('common.no')}
        </Button>,
        <Button
          type="primary"
          key="yes"
          onClick={() => {
            const values = {
              ...form.getFieldsValue(),
              all_child_active: true,
            };
            onFinishHandler(values);
          }}
        >
          {t('common.yes')}
        </Button>,
      ];
}
